import TextField from '@mui/material/TextField';
import React from 'react';

import { NumericFormatInput } from '@/components/atoms/NumericFormatInput';

interface Props {
  readonly id?: string;
  readonly label?: string;
  readonly htmlFor?: string;
  readonly name?: string;
  readonly value?: unknown;
  readonly defaultValue?: unknown;
}

export const NumericFormFieldInput: React.FC<Props> = (props: Props): React.ReactElement => {
  const { id, label, name, value, defaultValue } = props;

  return (
    <TextField
      id={id}
      label={label}
      name={name}
      slotProps={slotProps}
      defaultValue={defaultValue}
      value={value}
    />
  );
};

const slotProps = { htmlInput: { 'data-type': 'numeric', component: NumericFormatInput } };
